import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NavbarService {
    private _toggleDrawer$ = new Subject<void>();

    readonly toggleDrawer$ = this._toggleDrawer$.asObservable();

    toggleDrawer(): void {
        this._toggleDrawer$.next();
    }
}
